export const ALLOWED_NODE_TYPES = new Set([
  'AccessorNode',
  'ArrayNode',
  'ConditionalNode',
  'ConstantNode',
  'FunctionNode',
  'IndexNode',
  'OperatorNode',
  'ParenthesisNode',
  'SymbolNode',
]);

export const ALLOWED_OPERATORS = new Set([
  '+',
  '-',
  '*',
  '/',
  '%',
  '^',
  '==',
  '!=',
  '<',
  '<=',
  '>',
  '>=',
  'and',
  'or',
  'not',
  '!',
]);

export const SAFE_CONSTANTS = new Set(['e', 'pi', 'true', 'false', 'null']);
export const FORBIDDEN_PROPERTIES = new Set([
  '__proto__',
  'constructor',
  'prototype',
]);

export const CONDITIONAL_SYNTAX = 'ternary' as const;
